import React, { Component } from 'react';
import { Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import PubSub from 'pubsub-js';
import { Link } from 'react-router-dom';

// const profitFor = (data) => data.reduce((total, {longShort, qty, close}) => {
//     if (longShort === 'Buy') {
//       total += qty * close
//     } else {
//       total -= qty * close
//     }
//     return total
//   }, 0);

// const profitFor = (data) => data.reduce((r, { close, qty, longShort }) => ({
//     qty: (r.qty || 0) + qty,
//     sellTotal: (r.sellTotal || 0) + (longShort === 'Sell' ? qty : 0),
//     buyTotal: (r.buyTotal || 0) + (longShort === 'Buy' ? qty : 0),
//     profit: (r.profit || 0) + close * qty * (longShort === 'Sell' ? 1 : -1)
// }), {});

const uniqueArray = (obj) => obj.filter((value, index) => {
    const _value = JSON.stringify(value);
    return index === obj.findIndex(obj => {
        return JSON.stringify(obj) === _value;
    });
});

class ChartAlgoDisplay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            limit: this.props.limit,
            stratergy: '',
            stratergyNAme: '',
            order: this.props.order,
            text: this.props.text,
            internalStockAlgoList: [],
            profitList: [],
            reload: false,
        };
    }

    custom_sort(a, b) {
        return b.date.getTime() - a.date.getTime();
    }

    componentDidMount() {
        this.chartAlgoDisplayTrigger = PubSub.subscribe('chartAlgoDisplay', (topic, origData) => {
            if (origData !== undefined && origData.data !== undefined && origData.profitList !== undefined) {
                let stratergy = '', stratergyName = '', profit = [];
                if (origData.profitList !== undefined && origData.profitList.length !== undefined && origData.profitList.length > 0) {
                    profit = origData.profitList[this.state.order];
                    stratergy = profit.stratergy;
                    stratergyName = profit.stratergyName;
                }

                let data = origData.data;
                console.log('AlgoTrade chartAlgoDisplay Received data', data, origData);
                let tmpList = [];
                let length = this.state.limit;
                data.sort(this.custom_sort);
                console.log('Received algo data', data);
                let newData = uniqueArray(data.slice());
                //let newData = JSON.parse(JSON.stringify(data));

                if (newData !== undefined && newData.length > 0) {
                    for (var i = 0; i < newData.length; i++) {
                        if (tmpList.length !== undefined && tmpList.length >= length) {
                            break;
                        }

                        if (stratergy === 'EMA') {
                            newData[i].longShort = newData[i].emaLongShort;
                        }
                        if (stratergy === 'RSI') {
                            newData[i].longShort = newData[i].rsiLongShort;
                        }
                        if (stratergy === 'MACD') {
                            newData[i].longShort = newData[i].macdLongShort;
                        }
                        if (stratergy === 'SMA') {
                            newData[i].longShort = newData[i].smaLongShort;
                        }

                        if (newData[i].longShort !== undefined && newData[i].longShort === 'SHORT') {
                            newData[i].longShort = 'Sell';
                            tmpList.push(newData[i]);
                        }
                        if (newData[i].longShort !== undefined && newData[i].longShort === 'LONG') {
                            newData[i].longShort = 'Buy';
                            tmpList.push(newData[i]);
                        }
                    }

                    this.setState({ internalStockAlgoList: tmpList, profitList: [profit], stratergy: stratergy, stratergyName: stratergyName, reload: true });
                    console.log('Profit: ', stratergy, ' : ', profit);
                }
            }
        });
    }



    componentWillUnmount() {
        PubSub.unsubscribe(this.chartAlgoDisplayTrigger);
    }

    getFormattedDate(d) {
        const zeroPad = (num, places) => String(num).padStart(places, '0')
        return (d.getMonth() + 1) + '/' + d.getDate() + '/' + d.getFullYear() + ' ' + (d.getHours() > 12 ? d.getHours() - 12 : d.getHours()) + ':' + zeroPad(d.getMinutes(), 2);
    }

    renderRow(listValue) {
        let formattedDate = this.getFormattedDate(new Date(listValue.date));
        let noOfDecimals = parseFloat(listValue.close) < 1 ? 5 : 2;
        return (
            <tr key={listValue.close + listValue.date + Math.random()} style={{ color: listValue.longShort === 'Buy' ? 'green' : 'red' }} >
                {/* <td>{listValue.date.toLocaleDateString('en-US')}</td> */}
                <td>{formattedDate}</td>
                <td><i className={listValue.longShort === 'Buy' ? "fa fa-arrow-up" : "fa fa-arrow-down"}></i> {listValue.longShort}</td>
                <td>{parseFloat(listValue.close).toFixed(noOfDecimals)}</td>
            </tr>
        )
    }

    renderProfitRow(listValue) {
        let noOfDecimals = parseFloat(listValue.lastClose) < 1 ? 5 : 2;
        return (
            <tr key={Math.random()} style={{ fontWeight: 'bold' }}>
                <td>Total Buy: {listValue.totalBuy}</td>
                <td>Total Sell: {listValue.totalSell}, Total StopLoss(2%): {listValue.totalStopLoss}</td>
                <td style={{ color: listValue.totalProfit > 0 ? 'green' : 'red', fontWeight: 'bold' }}>Profit: {parseFloat(listValue.totalProfit).toFixed(noOfDecimals)}</td>
            </tr>
        )
    }

    render() {
        if (this.state.reload) {
            console.log('ChartAlgoDisplay Reloading...');
            this.setState({ reload: false });
            return <div>Loading...</div>;
        }

        let tableRow, profitRow;
        if (this.state.internalStockAlgoList !== undefined && this.state.internalStockAlgoList.length !== undefined && this.state.internalStockAlgoList.length > 0) {
            tableRow = this.state.internalStockAlgoList.map(this.renderRow.bind(this));
            profitRow = this.state.profitList.map(this.renderProfitRow.bind(this));
        } else {
            tableRow = <tr><td></td><td>No Data</td><td></td></tr>
            profitRow = <tr><td></td><td></td><td></td></tr>
        }

        console.log('stockAlgoList', this.state.stratergy, this.state.stratergyName, this.state.internalStockAlgoList);

        return (

            <Table bordered hover size="xs" style={{ fontSize: "10px", border: 'blue', backgroundColor: '#F0F0F0' }}>

                <thead>
                    <tr>
                        <th>Date</th>
                        <th>
                            <OverlayTrigger
                                placement="top"
                                overlay={<Tooltip id="button-tooltip-2">Click to see full backtest result
                                </Tooltip>}>
                                <Link to={'/algoBacktestResult'}>{this.state.text + ' (' + (this.state.stratergyName !== undefined ? this.state.stratergyName : '') + ')'}</Link>
                            </OverlayTrigger>
                        </th>
                        <th>Price
                            &nbsp;&nbsp;
                            <OverlayTrigger
                                placement="left"
                                overlay={<Tooltip id="button-tooltip-2">Backtested result with Algo/Indicator Buy/Sell signal at specific Datetime & Price.  Backtest runs on all historical data for the timeframe you select but only the latest 10 signals are displayed.  Stoploss is 2%.
                                </Tooltip>}>
                                <i style={{ color: '#8A2BE2', fontSize: '15px' }} className={"fa fa-question-circle"}></i>
                            </OverlayTrigger>
                        </th>
                    </tr>
                </thead>

                <tbody>
                    {tableRow}
                    {profitRow}
                </tbody>
            </Table>

        );
    }
}

export default ChartAlgoDisplay;
